var personalEmailRegex = /@(gmail|yahoo|hotmail|me|icloud|personal)\.com$/g;
export default personalEmailRegex;